// @flow
import React from 'react';
import _ from 'lodash';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import OptionList from 'models/OptionList';
import MoneyInput from 'components/shared/MoneyInputComponent';
import InputComponent from 'components/shared/InputComponent';
import BackButton from 'components/renter_application/BackButtonComponent';
import * as Layout from 'styles/Layout';
import ScreeningParamsStore from 'stores/ScreeningParamsStore';
import ScreeningParamsActions from 'actions/ScreeningParamsActions';
import * as Validations from 'validations/HomieValidations';
import SelectComponent from 'components/shared/SelectComponent';
import InputZipComponent from 'components/shared/InputZipComponent';
import NeigborhoodActions from 'actions/NeighborhoodActions';
import NeighborhoodStore from 'stores/NeighborhoodStore';
import $_ from 'jquery';

const InputSettings = {
  bottomPadding: 15,
  fontSize: 14
};

type PropsType = {
  homeApplication: any,
  onChange: (any, any) => void,
  nextAction: () => void,
  onPrevStep: () => void,
  onCancel: () => void,
  isOnlyEditIncome: boolean
};

type State = {
  number_of_branches: string,
  numberOfBranchesList: Array<OptionList>,
  company_size: string,
  foundation_year: string,
  invoiced_amount: string,
  principal_branch_address_street: string,
  principal_branch_address_ext_number: string,
  principal_branch_address_int_number: string,
  principal_branch_address_neighborhood: string,
  principal_branch_address_town: string,
  principal_branch_address_state: string,
  neighborhood: Array<any>,
  subMessageZip: string,
  generalError: boolean
};

export default class EarningsContentComponent extends React.Component<
  PropsType,
  State
> {
  state = this.defaultStateValues;

  get defaultStateValues(): any {
    const income = this.props.homeApplication.income || {};
    const codeZip = _.get(income, 'principal_branch_address.zip') || '';
    if (codeZip !== '')
      NeigborhoodActions.getNeighborhoods({ zip_code: codeZip });

    return {
      number_of_branches: _.get(income, 'company.number_of_branches') || 0,
      company_size: _.get(income, 'company.company_size') || '',
      foundation_year: _.get(income, 'company.foundation_year') || '',
      invoiced_amount: _.get(income, 'company.invoiced_amount') || '',
      principal_branch_address_street:
        _.get(income, 'principal_branch_address.street') || '',
      principal_branch_address_zip: codeZip,
      principal_branch_address_ext_number:
        _.get(income, 'principal_branch_address.ext_number') || '',
      principal_branch_address_int_number:
        _.get(income, 'principal_branch_address.int_number') || '',
      principal_branch_address_neighborhood:
        _.get(income, 'principal_branch_address.neighborhood') || '',
      principal_branch_address_town:
        _.get(income, 'principal_branch_address.town') || '',
      principal_branch_address_state:
        _.get(income, 'principal_branch_address.state') || '',
      numberOfBranchesList: [],
      neighborhood: [],
      subMessageZip: '',
      generalError: false
    };
  }

  componentWillMount() {
    NeighborhoodStore.addChangeListener(this.onNeighborhoods);
    ScreeningParamsStore.addChangeListener(
      this.onScreeningNumberOfBranchesChange
    );
  }

  componentWillUnmount() {
    NeighborhoodStore.removeChangeListener(this.onNeighborhoods);
    ScreeningParamsStore.removeChangeListener(
      this.onScreeningNumberOfBranchesChange
    );
  }

  componentDidMount() {
    ScreeningParamsActions.getScreeningParams({ name: 'number_of_branches' });
  }

  onNeighborhoods = (): void => {
    const neighborhoodRequest = NeighborhoodStore.getNeighborhoods();
    let neighborhoods = [];
    let subMessageZip = '';
    if (!neighborhoodRequest.length) {
      subMessageZip = 'Verifique el código postal';
    }
    neighborhoodRequest.map(neighborhood =>
      neighborhoods.push({
        value: neighborhood.name,
        label: neighborhood.name,
        id: neighborhood.id
      })
    );
    this.setState({ subMessageZip, neighborhood: neighborhoods });
  };

  searchNeigborhood = (codeZip: string): void => {
    this.setState(
      prevState => {
        prevState.principal_branch_address_state = '';
        prevState.principal_branch_address_town = '';
        prevState.principal_branch_address_neighborhood = '';
        return prevState;
      },
      () => NeigborhoodActions.getNeighborhoods({ zip_code: codeZip })
    );
  };

  onChangeNeighborhood = (ev: string, v: string): void => {
    if (this.state.principal_branch_address_neighborhood !== ev) {
      const neighborhoodIndex = this.state.neighborhood.filter(
        neighborhood => neighborhood.value === ev
      );
      const neighborhoodActive = NeighborhoodStore.getNeighborhoodById(
        neighborhoodIndex[0].id
      );
      this.setState(prevState => {
        prevState.principal_branch_address_state =
          neighborhoodActive.state.name;
        prevState.principal_branch_address_town = neighborhoodActive.city.name;
        prevState.principal_branch_address_neighborhood = ev;
        return prevState;
      });
    }
  };

  onScreeningNumberOfBranchesChange = () => {
    let numberOfBranchesList = [];
    const relationship = ScreeningParamsStore.getScreeningParam(
      'number_of_branches'
    );
    if (relationship !== undefined) {
      numberOfBranchesList = relationship.map(
        branch => new OptionList(branch.value, branch.name)
      );
    }
    this.setState({ numberOfBranchesList });
  };

  executeValidations = () => {
    document.querySelectorAll('form input').forEach(el => {
      el.focus();
      el.blur();
    });
  };

  resolveAfter = async () => {
    return new Promise(resolve => {
      setTimeout(() => {
        const lengthError = document.querySelectorAll('form .error-message')
          .length;
        resolve(lengthError);
      }, 250);
    });
  };

  isFieldsValidated = async (): Promise<boolean> => {
    let rErrors = await this.resolveAfter();
    return rErrors === 0;
  };

  handleSubmit = async (event: any) => {
    event.preventDefault();
    this.executeValidations();
    let valid = await this.isFieldsValidated();
    if (valid) {
      this.props.onChange(this.serializeState());
    } else {
      this.setState(
        {
          generalError: true
        },
        () => {
          $_('html, body, #Wrapper').animate({ scrollTop: 0 }, 500);
        }
      );
    }
  };

  serializeState = (): {} => {
    return {
      home_application_income: {
        company: {
          number_of_branches: _.get(this.state, 'number_of_branches'),
          company_size: _.get(this.state, 'company_size'),
          foundation_year: _.get(this.state, 'foundation_year'),
          invoiced_amount: _.get(this.state, 'invoiced_amount')
        },
        principal_branch_address_street: _.get(
          this.state,
          'principal_branch_address_street'
        ),
        principal_branch_address_ext_number: _.get(
          this.state,
          'principal_branch_address_ext_number'
        ),
        principal_branch_address_int_number: _.get(
          this.state,
          'principal_branch_address_int_number'
        ),
        principal_branch_address_neighborhood: _.get(
          this.state,
          'principal_branch_address_neighborhood'
        ),
        principal_branch_address_town: _.get(
          this.state,
          'principal_branch_address_town'
        ),
        principal_branch_address_zip: _.get(
          this.state,
          'principal_branch_address_zip'
        ),
        principal_branch_address_state: _.get(
          this.state,
          'principal_branch_address_state'
        )
      },
      step: 'income'
    };
  };

  onValidChange = (ev: string, v: string) => {
    this.setState(prevState => {
      prevState[v] = ev;
      return prevState;
    });
  };

  renderButton = () => {
    const { isOnlyEditIncome } = this.props;
    const submitText = isOnlyEditIncome ? 'Guardar' : 'Siguiente';
    return (
      <RenterApp.SubmitButton type="submit">
        {submitText}
      </RenterApp.SubmitButton>
    );
  };

  render() {
    const {
      neighborhood,
      principal_branch_address_zip,
      principal_branch_address_town,
      principal_branch_address_state,
      principal_branch_address_neighborhood
    } = this.state;
    const { isOnlyEditIncome } = this.props;
    return (
      <RenterApp.AppTabContainer>
        {!isOnlyEditIncome && (
          <RenterApp.BackButtonContainer onClick={this.props.onPrevStep}>
            <BackButton text={'Perfil'} />
          </RenterApp.BackButtonContainer>
        )}
        <RenterApp.AppTabForm>
          <form onSubmit={this.handleSubmit}>
            <RenterApp.Title>Cuéntanos más de la empresa</RenterApp.Title>
            <RenterApp.Subtitle>
              ¿En qué año comenzó a operar?
            </RenterApp.Subtitle>
            <RenterApp.StyledValidatedInput>
              <InputComponent
                name="foundation_year"
                value={this.state.foundation_year}
                type="text"
                onValueChange={this.onValidChange.bind(this)}
                schema={Validations.RequiredFieldSchema}
              />
            </RenterApp.StyledValidatedInput>
            <RenterApp.Subtitle>
              ¿Cuánto facturó el año pasado?
            </RenterApp.Subtitle>
            <MoneyInput
              textAlign="left"
              name={'invoiced_amount'}
              value={this.state.invoiced_amount}
              onValueChange={this.onValidChange.bind(this)}
              currency={'MXN'}
              currencySign={'$'}
            />
            <RenterApp.EndSectionSpace />
            <RenterApp.Title>¿Cuántas sucursales tiene?</RenterApp.Title>
            <SelectComponent
              name="number_of_branches"
              placeholder="Selecciona una opción"
              minSize={2}
              options={this.state.numberOfBranchesList}
              value={this.state.number_of_branches}
              isSearchable={false}
              onValueChange={this.onValidChange.bind(this)}
              schema={Validations.RequiredFieldSchema}
            />
            <RenterApp.EndSectionSpace />
            <RenterApp.Title>Dirección de la casa matriz</RenterApp.Title>
            <InputZipComponent
              type="text"
              name="principal_branch_address_zip"
              placeholder="Código postal"
              value={principal_branch_address_zip}
              fontSize={InputSettings.fontSize}
              schema={Validations.RequiredFieldSchema}
              onValueChange={this.onValidChange.bind(this)}
              searchNeigborhood={this.searchNeigborhood.bind(this)}
            >
              {this.state.subMessageZip !== '' ? (
                <RenterApp.SubtitleInput style={{ color: 'red' }}>
                  {this.state.subMessageZip}
                </RenterApp.SubtitleInput>
              ) : (
                <RenterApp.SubtitleInput>
                  Escribe tu código postal
                </RenterApp.SubtitleInput>
              )}
            </InputZipComponent>
            <SelectComponent
              name="principal_branch_address_neighborhood"
              placeholder="Colonia"
              options={neighborhood}
              isSearchable={true}
              value={principal_branch_address_neighborhood}
              schema={Validations.RequiredFieldSchema}
              onValueChange={this.onChangeNeighborhood}
              allowComponentUpdate={true}
            >
              <RenterApp.SubtitleInput>
                Busca tu colonia
              </RenterApp.SubtitleInput>
            </SelectComponent>
            <InputComponent
              type="text"
              name="principal_branch_address_town"
              placeholder="Delegación / Municipio"
              fontSize={InputSettings.fontSize}
              value={principal_branch_address_town}
              schema={Validations.RequiredFieldSchema}
              onValueChange={this.onValidChange.bind(this)}
              readOnly={true}
              allowComponentUpdate={true}
            />
            <InputComponent
              type="text"
              name="principal_branch_address_state"
              placeholder="Estado"
              fontSize={InputSettings.fontSize}
              value={principal_branch_address_state}
              schema={Validations.RequiredFieldSchema}
              onValueChange={this.onValidChange.bind(this)}
              readOnly={true}
              allowComponentUpdate={true}
            />
            <InputComponent
              name="principal_branch_address_street"
              value={this.state.principal_branch_address_street}
              type="text"
              placeholder="Calle"
              onValueChange={this.onValidChange.bind(this)}
              schema={Validations.RequiredFieldSchema}
            />
            <RenterApp.RowInputsContainer>
              <RenterApp.RowStyledInputContainer>
                <InputComponent
                  name="principal_branch_address_ext_number"
                  value={this.state.principal_branch_address_ext_number}
                  type="text"
                  placeholder="Número ext"
                  onValueChange={this.onValidChange.bind(this)}
                  schema={Validations.RequiredExtNumberSchema}
                />
              </RenterApp.RowStyledInputContainer>
              <Layout.Spacer />
              <RenterApp.RowStyledInputContainer>
                <InputComponent
                  name="principal_branch_address_int_number"
                  value={this.state.principal_branch_address_int_number}
                  type="text"
                  placeholder="Número int"
                  onValueChange={this.onValidChange.bind(this)}
                  schema={Validations.IntNumberSchema}
                />
              </RenterApp.RowStyledInputContainer>
            </RenterApp.RowInputsContainer>
            <RenterApp.EndSectionSpace />
            {this.renderButton()}
          </form>
        </RenterApp.AppTabForm>
        {!isOnlyEditIncome && (
          <RenterApp.CancelAppButton onClick={this.props.onCancel}>
            Cancelar aplicación
          </RenterApp.CancelAppButton>
        )}
      </RenterApp.AppTabContainer>
    );
  }
}
